import { render, staticRenderFns } from "./MessagePush.vue?vue&type=template&id=a91661f6&scoped=true"
import script from "./MessagePush.vue?vue&type=script&lang=js"
export * from "./MessagePush.vue?vue&type=script&lang=js"
import style0 from "./MessagePush.vue?vue&type=style&index=0&id=a91661f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91661f6",
  null
  
)

export default component.exports